import { render, staticRenderFns } from "./exhibition-cret-En.vue?vue&type=template&id=553a1b37&scoped=true&"
import script from "./exhibition-cret-En.vue?vue&type=script&lang=js&"
export * from "./exhibition-cret-En.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-cret-En.vue?vue&type=style&index=0&id=553a1b37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a1b37",
  null
  
)

export default component.exports